import { InteractiveMap } from './InteractiveMap';

export function Map({ location, handleClick, readOnly = false }) {
  return (
    <InteractiveMap
      location={location}
      onLocationChange={handleClick}
      readOnly={readOnly}
      showSearch={false}
      geocodeOnPlace={false}
    />
  );
}
